import { TableCell } from "@mui/material"

const TableHeaderCell = ({children}) => {
    return <TableCell sx={{fontWeight: 'bold'}}>{children}</TableCell>
}

export default TableHeaderCell;